import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { PdfBarCodeGenerator } from '../pdf-bar-code-generator';
import IntealthLogo from '../../../../assets/intealth-logo-with-text.png';

interface PdfHeaderProps {
  data: any;
}

export const PdfHeaderV2: React.FC<PdfHeaderProps> = (props) => {
  const styles = StyleSheet.create({
    image: {
      maxWidth: 200,
      width: 200,
      maxHeight: 50,
      height: 50,
      marginRight: 15,
      marginLeft: 80
    },
    text: {
      fontSize: '9px',
      width: '100%',
      textAlign: 'center',
      fontFamily: 'Libre Franklin Bold'
    },
    leftColumn: {
      flexDirection: 'row',
      paddingTop: 10
    },
    row: {
      width: '95%',
      paddingTop: 5,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    },
    divider: {
      height: '1px',
      border: 0,
      borderTop: '1px solid black',
      color: '#00FFFF',
      marginLeft: 40,
      marginRight: '35%',
      marginTop: 2
    }
  });

  return (
    <>
      <View style={styles.row}>
        <Image style={{ width: '18%', marginLeft: '40' }} src={IntealthLogo} />

        <Text style={{ fontSize: '16px', color: '#2b2b53', fontFamily: 'Libre Franklin Bold', paddingLeft: 35, paddingBottom: 5}}>Health Professionals Identification Form</Text>

        <View style={styles.image}>
          <PdfBarCodeGenerator barCodeValue={props.data.caseId} barCodeWidth={1} barCodeHeight={40} barCodeFontSize={12} />
        </View>
      </View>
      <Text style={styles.divider}></Text>
    </>
  );
};
export default PdfHeaderV2;
